import { render, staticRenderFns } from "./ManejadorStatus.vue?vue&type=template&id=2633115d&"
import script from "./ManejadorStatus.vue?vue&type=script&lang=js&"
export * from "./ManejadorStatus.vue?vue&type=script&lang=js&"
import style0 from "./ManejadorStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports